/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrSummaryRowSection } from './igr-summary-row-section';
import { SummaryRowSection } from './SummaryRowSection';
import { TypeRegistrar } from "igniteui-react-core";
var IgrSummaryRowSectionModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrSummaryRowSectionModule() {
    }
    IgrSummaryRowSectionModule.register = function () {
        TypeRegistrar.registerCons("IgrSummaryRowSection", IgrSummaryRowSection);
        TypeRegistrar.register("SummaryRowSection", SummaryRowSection.$type);
    };
    return IgrSummaryRowSectionModule;
}());
export { IgrSummaryRowSectionModule };
//# sourceMappingURL=igr-summary-row-section-module.js.map
